import React from "react";
import { Link } from "react-router-dom";
import Navbar from "../components/Navbar";
import IconGroup from "./IconGroup";
import Whitearrow from "../assets/generalicons/arrow-right-white.png";
import ArrowDown from "../assets/generalicons/arrow_down.png";
import Shelcia from "../assets/shelcia.png";
import { Animated } from "react-animated-css";

const LandingPage = () => {
  return (
    <React.Fragment>
      <div className="container">
        <Navbar />
        <Animated animationIn="fadeInUp" isVisible={true}>
          <div className="box">
            <div className="row">
              <div className="col-sm-6">
                <div className="custom-card">
                  <div className="card-body">
                    <h6>
                      Hi ! I am Shelcia, an aspiring MERN stack Website
                      Developer and Designer based in Chennai
                    </h6>
                    <p className="mb-2">
                      Check out my work
                      <Link to="/work">
                        <img
                          src={ArrowDown}
                          alt="arrow"
                          height="10px"
                          style={{ paddingLeft: "15px" }}
                          className="arrow-down"
                        />
                      </Link>
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-sm-6">
                <div className="card red">
                  <div className="card-body">
                    <img
                      src={Shelcia}
                      alt="shelcia"
                      className="profilepic"
                      loading="eager"
                    />
                    <h6 className="white">
                      Check out my
                      <br /> NEW PROJECT!
                      <a
                        href="https://github.com/shelcia/crm-frontend"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <img
                          src={Whitearrow}
                          alt="arrow"
                          height="15px"
                          style={{ paddingLeft: "5px" }}
                          className="arrowstrans"
                        />
                      </a>
                    </h6>
                    <IconGroup />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Animated>
      </div>
    </React.Fragment>
  );
};

export default LandingPage;
